import React from "react";
import { motion } from "framer-motion";
// import {Link, BrowserRouter, Switch, Route} from "react-router-dom";
import ButtonNext from "../../../ButtonNext/ButtonNext";

const Pertidaksamaan = ({ click }) => {
	return (
		<div className="container-fluid">
			<div>
				<motion.h1
					initial={{ y: 500 }}
					animate={{
						y: 0,
						transition: { duration: 0.5, type: "spring" },
					}}
					exit={{
						y: -500,
						transition: { duration: 0.5, type: "spring", ease: "easeInOut" },
					}}
				>
					<div className="row">
						<div className="col-sm-12" style={{

						}}>
							<div className="text-center">
								<h1>Sistem Pertidaksamaan</h1>
								<h1>Linear Dua Variabel</h1>
							</div>
						</div>
					</div>
				</motion.h1>
				<div className="row">
					<div>
						<div style={{ marginTop: "1rem" }}>
							<ButtonNext click={click} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Pertidaksamaan;
